<mat-card-header [class.nsc-card-title--error]="error">
  <mat-card-title>
    <h3 [attr.aria-labelledby]="title">
      <ng-content></ng-content><span aria-hidden="true" class="nsc-card-title__note mat-caption" *ngIf="note">{{ note }}</span></h3>
  </mat-card-title>
</mat-card-header>